import React, { useContext, useState } from "react"
import ServicosContext from "../../contexts/servicosContext"

import api from "../../services/api"

import { RegistrarLogErro } from "../../services/clientefiel"

import Button from "@material-ui/core/Button"
import CssBaseline from "@material-ui/core/CssBaseline"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import Snackbar from "@material-ui/core/Snackbar"
import { makeStyles } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import MuiAlert from "@material-ui/lab/Alert"
import { Col, Row } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import background from "../../assets/background-min.jpg"
import { enviarCodigo, validarCodigo } from "../../services/validacaoEmail"
import useAppStore from "../../stores/AppStore"
import Loading from "../Componentes/Loading"
import { sincronizarConfiguracoesDeTexto } from "../textoImpressao/context/textoImpressaoLocal"
import DialogCodigoEmail from "./DialogCodigoEmail"
import RecaptchaV2 from "./RecaptchaV2"
import {
    ehDispositivoConfiavel,
    marcarDispositivoConfiavel,
    mascararEmail,
} from "./dispositivoConfiavel"
import "./styles.css"
const useStyles = makeStyles(theme => ({
    container: {
        margin: 0,
        padding: 0,
        minHeight: "100vh",
        width: "100%",
        background: `url('${background}') no-repeat center center fixed`,
        backgroundSize: "cover",

        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    root: {
        width: "100%",
        margin: "1em 0",
    },
    pos: {
        marginBottom: 12,
    },
}))

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}

export default function Login() {
    const aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))

    const history = useHistory()
    const classes = useStyles()

    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)

    const [usuario, setUsuario] = useState("")
    const [senha, setSenha] = useState("")
    const [mostrarSenha, setMostrarSenha] = useState(false)

    // reCAPTCHA v2: o backend passa a exigir após 3 senhas erradas do mesmo e-mail.
    const [captchaSiteKey, setCaptchaSiteKey] = useState("")
    const [captchaToken, setCaptchaToken] = useState("")
    const [captchaReset, setCaptchaReset] = useState(0)
    const [loading, setLoading] = React.useState(false)
    const [alert, setAlert] = useState({ status: false, tipo: "success", mesangem: "" })

    // 2FA por e-mail (perfil CLIENTEFIEL)
    const [dialogCodigo, setDialogCodigo] = useState(false)
    const [loginPendente, setLoginPendente] = useState(null) // { hash, dados }
    const [erroCodigo, setErroCodigo] = useState("")
    const [loadingCodigo, setLoadingCodigo] = useState(false)
    const [segundosCooldown, setSegundosCooldown] = useState(0)

    const { buscarParametrosLogin } = useContext(ServicosContext)

    if (localStorage.getItem("chaveSistema")) {
        history.push("/servicos")
    }

    const alertStart = (msg, tipo) => {
        setAlert({ status: true, tipo: tipo, mesangem: msg })
    }

    const alertClose = (event, reason) => {
        if (reason === "clickaway") {
            return
        }
        setAlert({ status: false, tipo: alert.tipo, mesangem: alert.mesangem })
    }

    async function finalizarLogin(hash, dados) {
        localStorage.setItem("chaveSistema", hash)
        // Loja selecionada (troca de estabelecimento) é por conta e só existe quando o
        // próprio usuário troca de loja. Zera no login para uma conta nova não herdar a
        // loja de uma sessão anterior — senão o header "estabelecimento" (api.js) sairia
        // com um id de OUTRA conta. A conta inicia no seu estabelecimento padrão.
        localStorage.removeItem("estabelecimentoAtualCF")

        atualizarConfiguracoes({
            user: {
                id: dados.id,
                perfil: dados.perfil,
                usuario: dados.email,
                parametros: await buscarParametrosLogin(hash),
            },
        })

        // ADMINISTRADOR e CLIENTEFIEL iniciam no resumo; demais perfis no painel de serviços.
        history.push(
            ["ADMINISTRADOR", "CLIENTEFIEL"].includes(dados.perfil)
                ? "/servicos/modulo/resumo?inicial=1"
                : "/servicos"
        )

        window.dispatchEvent(new CustomEvent("login"))
    }

    async function iniciarValidacaoCodigo(hash, dados) {
        setLoginPendente({ hash, dados })
        setErroCodigo("")
        setSegundosCooldown(0)
        setDialogCodigo(true)

        const resultado = await enviarCodigo(dados.email)
        if (!resultado.sucesso && resultado.segundosRestantes) {
            // Já dentro do cooldown: abre o dialog com o contador do reenvio.
            setSegundosCooldown(resultado.segundosRestantes)
        } else if (!resultado.sucesso) {
            setErroCodigo(resultado.erro || "Não foi possível enviar o código")
        }
    }

    async function confirmarCodigo(codigo) {
        if (!loginPendente) return
        setLoadingCodigo(true)
        setErroCodigo("")
        try {
            const { dados, hash } = loginPendente
            const resultado = await validarCodigo(dados.email, codigo)
            if (resultado.valido) {
                marcarDispositivoConfiavel(dados.email)
                setDialogCodigo(false)
                setLoginPendente(null)
                await finalizarLogin(hash, dados)
            } else {
                setErroCodigo(resultado.erro || "Código inválido ou expirado")
            }
        } catch (error) {
            RegistrarLogErro(error, "ConfirmarCodigoLogin")
            setErroCodigo("Erro ao validar o código. Tente novamente.")
        } finally {
            setLoadingCodigo(false)
        }
    }

    async function reenviarCodigo() {
        if (!loginPendente) return
        setLoadingCodigo(true)
        setErroCodigo("")
        try {
            const resultado = await enviarCodigo(loginPendente.dados.email)
            if (!resultado.sucesso) {
                if (resultado.segundosRestantes) setSegundosCooldown(resultado.segundosRestantes)
                setErroCodigo(resultado.erro || "Não foi possível reenviar o código")
            }
        } finally {
            setLoadingCodigo(false)
        }
    }

    const fecharDialogCodigo = () => {
        setDialogCodigo(false)
        setLoginPendente(null)
        setErroCodigo("")
    }

    async function realizarLogin_UsuarioSenha(e = false) {
        if (e) {
            e.preventDefault()
        }

        setLoading(true)
        try {
            // alertStart("Fazendo login", "warning")
            setLoading(true)

            const fornecedor = {
                appNome: aplicativoDados?.appNome,
                email: usuario,
                hashSenha: senha,
                codigoDispositivo: "SistemaReact",
                token: "a~I?;;+_@!AL^",
                captchaToken: captchaToken || undefined,
            }
            await api
                .post(`fornecedor/LoginFornecedor`, fornecedor, {
                    headers: { "Content-Type": "application/json" },
                })
                .then(async response => {
                    // O token do captcha é de uso único: reinicia a caixa a cada tentativa.
                    if (captchaSiteKey) setCaptchaReset(n => n + 1)

                    if (typeof response.data == "string") {
                        alertStart("Erro nao esperado ao logar o fornecedor ", "error")
                    } else if (response.data.codErro > 0) {
                        if (response.data.exigeCaptcha && response.data.captchaSiteKey) {
                            setCaptchaSiteKey(response.data.captchaSiteKey)
                        }
                        if (response.data.mensagem === "CAPTCHA") {
                            alertStart('Por segurança, marque "Não sou um robô" e tente de novo', "warning")
                        } else if (response.data.mensagem === "2") {
                            alertStart("Usuário e/ou senha inválidos", "error")
                        }
                    } else {
                        setCaptchaSiteKey("")
                        const token = usuario + ":" + senha
                        const hash = "Basic " + btoa(unescape(encodeURIComponent(token)))

                        const ehAmbienteLocal = /^(localhost$|127\.0\.0\.1$|192\.168\.)/.test(
                            window.location.hostname
                        )

                        const precisaCodigo =
                            !ehAmbienteLocal &&
                            response.data.perfil === "CLIENTEFIEL" &&
                            !ehDispositivoConfiavel(response.data.email)
                        sincronizarConfiguracoesDeTexto(hash)

                        if (precisaCodigo) {
                            await iniciarValidacaoCodigo(hash, response.data)
                        } else {
                            await finalizarLogin(hash, response.data)
                        }
                    }
                })

            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "LoginGeral")
            alertStart("Erro nao identificado LoginGeral", "error")
            setLoading(false)
        }
    }

    return (
        <Row className={classes.container}>
            <Loading loading={loading} />

            <Snackbar open={alert.status} autoHideDuration={6000} onClose={alertClose}>
                <Alert onClose={alertClose} severity={alert.tipo}>
                    {alert.mesangem}
                </Alert>
            </Snackbar>

            <CssBaseline />

            <Col xs={12} md={12} lg={3}></Col>
            <Col xs={12} md={12} lg={6} style={{ height: "minContent" }}>
                <div
                    style={{
                        padding: "2em",
                        background: "white",
                        textAlign: "center",
                        borderRadius: "15px",
                    }}
                >
                    <img src={aplicativoDados.urlLogo} style={{ height: "200px" }} alt="" />

                    <form
                        className={(classes.form, "container")}
                        onSubmit={realizarLogin_UsuarioSenha}
                    >
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            onChange={e => setUsuario(e.target.value)}
                            id="usuario"
                            value={usuario}
                            label="Email / Telefone"
                            name="usuario"
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            value={senha}
                            onChange={e => setSenha(e.target.value)}
                            name="senha"
                            label="Senha"
                            type={mostrarSenha ? "text" : "password"}
                            id="senha"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                                            title={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                                            onClick={() => setMostrarSenha(m => !m)}
                                            onMouseDown={e => e.preventDefault()}
                                            edge="end"
                                        >
                                            {mostrarSenha ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        {captchaSiteKey && (
                            <RecaptchaV2
                                siteKey={captchaSiteKey}
                                onChange={setCaptchaToken}
                                resetKey={captchaReset}
                            />
                        )}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            disabled={!!captchaSiteKey && !captchaToken}
                        >
                            Entrar
                        </Button>
                    </form>
                </div>
            </Col>

            <Col xs={12} md={12} lg={3}></Col>

            <DialogCodigoEmail
                open={dialogCodigo}
                emailMascarado={mascararEmail(loginPendente?.dados?.email)}
                loading={loadingCodigo}
                erro={erroCodigo}
                segundosRestantesIniciais={segundosCooldown}
                onConfirmar={confirmarCodigo}
                onReenviar={reenviarCodigo}
                onClose={fecharDialogCodigo}
            />
        </Row>
    )
}
